import MomentRules from "./containers/MomentRules";
export default MomentRules;